import { render } from "./MyCourseCard.vue?vue&type=template&id=c36976ec&scoped=true"
import script from "./MyCourseCard.vue?vue&type=script&lang=js"
export * from "./MyCourseCard.vue?vue&type=script&lang=js"

import "./MyCourseCard.vue?vue&type=style&index=0&id=c36976ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36976ec"]])

export default __exports__